import {SERVICE_ENDPOINT} from "../const";
import {gatewayInstance} from "../axiosInstance";

export const regionDropdown = async() => {
    try{
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/region/dropdown`
        );

        return response.data.map((item) => ({
            key: item.regId,
            text: item.regRegion,
            value: item.regId,
        }));
    }catch (e) {
        console.error(e);
    }
};

export const createRegion = async(data) => {
    try{
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/region/create`,
            data,
        );
        return response.data;
    }catch (e) {
        console.error(e);
    }
}

export const updateRegion = async(id, data) => {
    try{
        const response = await gatewayInstance.put(
            `${SERVICE_ENDPOINT.TRANSPORT}/region/update/${id}`,data
        );
        return response.data;
    }catch (e) {
        console.error(e);
    }
}

export const getByIdRegion = async (id) => {
    try{
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/region/get-by/${id}`
        )
        return response.data;
    }catch (error) {
        console.error(error);
    }
}